import { all, call, takeLatest, put, select } from 'redux-saga/effects';

import { DATA_REQUEST_BEGIN } from 'app/dealer/shared/higherOrderReducers/withDataRequest/actionTypeFormatters';
import { getDateRangeAsync } from 'app/dealer/shared/modules/dealersInsights/redux/dateRange/sagas';

import {
  getListingsBenchmarkTopListingsDataAsync,
  watchTopListingsTrackingActions,
} from '../topListings/sagas';
import { getListingsBenchmarkListingsTurnoverAsync } from '../listingsTurnover/sagas';
import { getListingsBenchmarkListingsImagesAsync } from '../listingsImages/sagas';
import { LISTINGS_BENCHMARK_REDUCER_NAME } from '../constants';
import { disableListingsTileCountup } from '../listings/actions';
import { getListingsDataAsync } from '../listings/sagas';
import { selectListingsTileCountUpDisabled } from '../listings/selectors';

import { listingsBenchmarkDataRequestComplete } from './actions';
import { selectListingsBenchmarkFirstDataRequestCompleted } from './selectors';

export function* checkListingsTileCountupAnimationState() {
  // if the first data request happened and the animation has not been disabled,
  // disable further count up animations in the UI
  const listingTileCountupDisabled = yield select(
    selectListingsTileCountUpDisabled,
  );
  const firstDataRequestCompleted = yield select(
    selectListingsBenchmarkFirstDataRequestCompleted,
  );
  if (!listingTileCountupDisabled && firstDataRequestCompleted) {
    yield put(disableListingsTileCountup());
  }
}

/**
 * @description
 * main saga - is called on every data request to ensure all
 * necessary data is available
 */
export function* getListingsBenchmarkDataAsync() {
  // checks listing tile countup animation state
  yield call(checkListingsTileCountupAnimationState);

  const hasDateRange = yield call(getDateRangeAsync);
  // if there is a date range, continue saga
  // date picker triggers data request flow for the entire listings benchmark panel

  if (hasDateRange) {
    yield all([
      call(getListingsDataAsync),
      call(getListingsBenchmarkTopListingsDataAsync),
      call(getListingsBenchmarkListingsTurnoverAsync),
      call(getListingsBenchmarkListingsImagesAsync),
    ]);
  }

  // notify us when the saga is over
  yield put(listingsBenchmarkDataRequestComplete());
}

export function* watchGetDataRequest() {
  yield takeLatest(
    DATA_REQUEST_BEGIN(LISTINGS_BENCHMARK_REDUCER_NAME),
    getListingsBenchmarkDataAsync,
  );
}

export function* watchListingsBenchmarkGeneralSaga() {
  yield all([call(watchGetDataRequest), call(watchTopListingsTrackingActions)]);
}
